package com.example.mystybag.common.views

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.style.TextAlign
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.extensions.keyboardPadding
import com.example.mystybag.common.logic.DualTextInputBottomSheetViewModel
import com.example.mystybag.common.ui.components.custom.DefaultCircleShapedTextFieldCursor
import com.example.mystybag.common.views.ActionSheetHeader
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.defines.TextFieldType
import com.example.mystybag.core.ui.theme.LocalTheme
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.views.AppTheme
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun DualTextInputBottomSheetView(viewModel: DualTextInputBottomSheetViewModel) {
    val state          = viewModel.uiState.subscribeAsState()
    val focusRequester = remember { FocusRequester() }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = p16)
            .focusRequester(focusRequester)
            .keyboardPadding(),
        horizontalAlignment = Alignment.Start
    ) {
        ActionSheetHeader(
            title = state.value.title.ifBlank { null },
            showDivider = true,
            onCloseClick = viewModel::parentCloseBottomSheet
        )

        DefaultCircleShapedTextFieldCursor(
            label           = state.value.hint1,
            modifier        = Modifier
                .fillMaxWidth()
                .padding(top = p32),
            value           = state.value.text1,
            onValueChange   = viewModel::onText1Changed,
            inputType       = TextFieldType.NAME,
            isError         = false,
            errorText       = "",
            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Next)
        )

        DefaultCircleShapedTextFieldCursor(
            label           = state.value.hint2,
            modifier        = Modifier.fillMaxWidth().padding(top = p32),
            value           = state.value.text2,
            onValueChange   = viewModel::onText2Changed,
            inputType       = TextFieldType.NAME,
            isError         = state.value.isError,
            errorText       = state.value.errorText,
            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done)
        )

        DefaultButton(
            caption  = state.value.buttonText,
            modifier = Modifier.padding(top = p32, bottom = p32),
            callback = viewModel::onButtonClicked
        )
    }

    LaunchedEffect(Unit) {
        launch {
            delay(300)
            focusRequester.requestFocus()
        }
    }
}
